/** The file was automatically generated. Please do not modify manually */
import en from './online.json';
export var strings_en = en;
